module.exports = __webpack_public_path__ + "static/media/favicon.e459fb0f.png";